import { tokensRaw } from '@vp/swan';

export const SvgSubmit = ({ backgroundColor = tokensRaw.SwanBaseColorGreen100 }) => {
    return (
        <svg
            width="68"
            height="68"
            viewBox="0 0 68 68"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="34" cy="34" r="34" fill={backgroundColor} />
            <g clip-path="url(#clip0_310_740)">
                <path
                    d="M16.12 17.6494C16.12 16.4071 17.1248 15.4 18.3643 15.4H43.2757C44.5152 15.4 45.52 16.4071 45.52 17.6494V36.3759H43.2757V17.6494L18.3643 17.6494V47.4663L24.59 42.4408C24.9889 42.1188 25.4856 41.9433 25.9977 41.9433H36.9356V44.1927H25.9977L19.772 49.2182C18.3037 50.4035 16.12 49.3559 16.12 47.4663V17.6494Z"
                    fill="black"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M20.8535 24.029C20.8535 23.3646 21.3921 22.826 22.0565 22.826L39.5001 22.826C40.1645 22.826 40.7031 23.3646 40.7031 24.029C40.7031 24.6934 40.1645 25.232 39.5001 25.232L22.0565 25.232C21.3921 25.232 20.8535 24.6934 20.8535 24.029Z"
                    fill="black"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M20.8535 28.4396C20.8535 27.7752 21.3921 27.2366 22.0565 27.2366L39.5001 27.2366C40.1645 27.2366 40.7031 27.7752 40.7031 28.4396C40.7031 29.104 40.1645 29.6426 39.5001 29.6426L22.0565 29.6426C21.3921 29.6426 20.8535 29.104 20.8535 28.4396Z"
                    fill="black"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M20.8535 33.3565C20.8535 32.6921 21.3921 32.1535 22.0565 32.1535L39.5001 32.1535C40.1645 32.1535 40.7031 32.6921 40.7031 33.3565C40.7031 34.0209 40.1645 34.5595 39.5001 34.5595L22.0565 34.5595C21.3921 34.5595 20.8535 34.0209 20.8535 33.3565Z"
                    fill="black"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M44.98 52.0353C49.0091 52.0353 52.2753 48.7691 52.2753 44.74C52.2753 40.7109 49.0091 37.4447 44.98 37.4447C40.9509 37.4447 37.6847 40.7109 37.6847 44.74C37.6847 48.7691 40.9509 52.0353 44.98 52.0353ZM44.98 54.28C50.2488 54.28 54.52 50.0088 54.52 44.74C54.52 39.4712 50.2488 35.2 44.98 35.2C39.7112 35.2 35.44 39.4712 35.44 44.74C35.44 50.0088 39.7112 54.28 44.98 54.28Z"
                    fill="black"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M50.113 41.8915C50.55 42.3324 50.5488 43.0462 50.1104 43.4857L44.9375 48.6711C44.5001 49.1096 43.7924 49.1096 43.355 48.6711L40.5696 45.879C40.1311 45.4394 40.13 44.7257 40.567 44.2848C41.004 43.8438 41.7137 43.8426 42.1522 44.2822L44.1463 46.2811L48.5278 41.8889C48.9663 41.4494 49.676 41.4505 50.113 41.8915Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_310_740">
                    <rect width="48" height="48" fill="white" transform="translate(10 10)" />
                </clipPath>
            </defs>
        </svg>
    );
};
